import { State as _DataExecuters } from "./Executors/data/interface";
import { State as _DataExecutorLocations } from "./ExecutorLocations/data/interface";
import { State as _DataExecutorGroup } from "./ExecutorGroup/data/interface";
import { State as _DataExecutorRate } from "./ExecutorRate/data/interface";
import { State as _DataCustomerBalanceRule } from "./CustomerBalanceRule/data/interface";
import { State as _DataExecutorPenalty } from "./ExecutorPenalty/data/interface";
import { State as _DataExecutorRating } from "./ExecutorRating/data/interface";
import { State as _DataDispatcherRate } from "./DispatcherRate/data/interface";
import { State as _DataRole } from "./Role/data/interface";
import { State as _DataMultySelectModals } from "./MultySelectModals/data/interface";

export namespace GlobalState {
	export namespace Executors {
		export interface DataExecuters extends _DataExecuters {}
	}

	export namespace ExecutorLocations {
		export interface DataExecutorLocations extends _DataExecutorLocations {}
	}

	export namespace ExecutorGroup {
		export interface DataExecutorGroupextends extends _DataExecutorGroup {}
	}

	export namespace ExecutorRate {
		export interface DataExecutorRate extends _DataExecutorRate {}
	}

	export namespace CustomerBalanceRule {
		export interface DataCustomerBalanceRule
			extends _DataCustomerBalanceRule {}
	}

	export namespace ExecutorPenalty {
		export interface DataExecutorPenalty extends _DataExecutorPenalty {}
	}

	export namespace ExecutorRating {
		export interface DataExecutorRating extends _DataExecutorRating {}
	}

	export namespace DispatcherRate {
		export interface DataDispatcherRate extends _DataDispatcherRate {}
	}

	export namespace Role {
		export interface DataRole extends _DataRole {}
	}

	export namespace MultySelectModals {
		export interface DataMultySelectModals extends _DataMultySelectModals {}
	}

	export const ConstantGlobalStateSlice = {
		EXECUTORS_DATA: "globalState/executors/data",
		EXECUTOR_LOCATIONS_DATA: "globalState/executorLocations/data",
		EXECUTOR_GROUP_DATA: "globalState/executorGroup/data",
		EXECUTOR_RATE_DATA: "globalState/executorRate/data",
		CUSTOMER_BALANCE_RULE_DATA: "globalState/customerBalanceRule/data",
		EXECUTOR_PENALTY_DATA: "globalState/executorPenalty/data",
		EXECUTOR_RATING_DATA: "globalState/executorRating/data",
		DISPATCHER_RATE_DATA: "globalState/dispatcherRate/data",
		ROLE_DATA: "globalState/role/data",
		CAR_SECTORS_DATA: "globalState/carSectors/data",
		CAR_PARK_DATA: "globalState/carPark/data",
		MULTY_SELECT_MODALS_DATA: "globalState/multySelectModals/data",
		PRIZE_ZONES_DATA: "globalState/prizeZones/data",
		PARKING_DATA: "globalState/parking/data",
	};
}
